import React from 'react'
import Link from 'gatsby-link'
import { css } from 'emotion'
import get from 'lodash/get'
import { Helmet } from 'react-helmet'
import Img from 'gatsby-image'
import PageHero from '../components/PageHero'
import { Button, ButtonOutline } from '../utils/styles'

const AboutPage = (props) => {
  const about = get(props, 'data.prismicAbout', false)
  return (
    <div css={{ paddingBottom: 30 }}>
      <Helmet>
        <title>About – Patrícia Marques</title>
        <meta name="descritpion" value="Learn more about the artist behind de work." />
      </Helmet>
      <PageHero title="About" small="Patrícia Marques" />
      <Img
        sizes={about.data.image.localFile.childImageSharp.sizes}
        css={{
          '@media (min-width: 800px)': {
            borderRadius: 5,
          }
        }}
      />
      <section css={{ padding: '30px' }}>
        <div
          dangerouslySetInnerHTML={{ __html: about.data.content.html }}
          css={{ margin: '30px 0 80px' }}
        />
        
        <h2>Clients</h2>
        <ul
          css={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            listStyle: 'none',
            margin: '0 0 60px',
            padding: 0,
          }}
        >
          {about.data.clients.map((client, index) => (
            <li
              key={index}
              css={{ margin: 0 }}>
              <a
                href={client.website.url} title={client.name.text}
                css={{
                  alignItems: 'center',
                  border: 0,
                  display: 'flex',
                  filter: 'grayscale()',
                  height: 100,
                  justifyContent: 'center',
                  maxWidth: 140,
                  padding: 20,

                  '&::before': { display: 'none' },

                  '&:hover': {
                    boxShadow: '0 0 10px rgba(0, 0, 0, .1), 0 5px 10px rgba(0, 0, 0, .1)',
                    filter: 'none',
                  },
                }}
              >
                <Img
                  sizes={client.logo.localFile.childImageSharp.sizes}
                  css={{ width: 100 }}
                />
              </a>
            </li>
          ))}
        </ul>

        <a
          href={'mailto:contacto@patriciamarques.me'}
          title="Get in touch"
          className={Button}
        >
          Hire
        </a>
        <Link to="portfolio" className={ButtonOutline}>Portfolio</Link>
      </section>
    </div>
  )
}

export default AboutPage

export const aboutQuery = graphql`
  query About {
    prismicAbout {
      data {
        title { text }
        image {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920, quality: 90, traceSVG: { color: "#021212" }) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
        content { html }
        clients {
          name { text }
          website { url }
          logo {
            localFile {
              childImageSharp {
                sizes(maxWidth: 150, quality: 90, traceSVG: { color: "#021212" }) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/about.js